import SmkAsyncSelect from 'components/SmkAsyncSelect';
import { isEmpty } from 'lodash';
import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { API_BASE_URL, taxonomyType } from 'utils/constants';
import { htmlDecode } from 'utils/helper';

const GroupCategoriesSearch = ({ formik }) => {
  const handleSelectChange = (res) => {
    const currentGroup = !isEmpty(formik?.values?.categories) ? formik?.values?.categories : [];

    const isAlreadySelected = currentGroup?.some((item) => item?.id === res?.id);

    if (!isAlreadySelected) {
      const updatedGroup = [
        ...currentGroup,
        {
          name: res?.name,
          id: res?.id,
        },
      ];
      formik.setFieldValue('categories', updatedGroup);
    }
  };

  const handleRemoveItem = (id) => {
    const updatedGroup = formik.values.categories?.filter((item) => item?.id !== id);
    formik.setFieldValue('categories', updatedGroup);
  };

  return (
    <Card>
      <CardBody>
        <div className="mb-3">
          <CardTitle className="mb-3"> Group Categories</CardTitle>
          <SmkAsyncSelect
            acceptedKey={'name'}
            acceptedValue={'id'}
            placeholder="Type category name.."
            onChange={handleSelectChange}
            fetchUrl={`${API_BASE_URL}/common/admin/taxonomy/search`}
            filters={{
              autoComplete: true,
              active: true,
              page: 1,
              size: 20,
              sortBy: 'id',
              sortOrder: 0,
              language: 'en',
              type: taxonomyType.COMMUNITY_GROUP_CATEGORY,
            }}
            searchKeyName="name"
          />
        </div>

        {!isEmpty(formik?.values?.categories) &&
          formik.values?.categories?.map((item, index) => (
            <div
              key={item.id}
              className="bg-light rounded-2 p-3 d-flex justify-content-between align-items-center mt-3  ">
              <h6 className="mb-0">
                {index + 1}. {htmlDecode(item.name)}
              </h6>
              <button className="btn btn-md btn-danger" type="button" onClick={() => handleRemoveItem(item.id)}>
                Remove
              </button>
            </div>
          ))}
      </CardBody>
    </Card>
  );
};

export default GroupCategoriesSearch;
